import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {  initReactI18next } from "react-i18next";
// import backend from "i18next-xhr-backend";

import ko from './locales/ko/translation.json'
import en from './locales/en/translation.json'
import jp from './locales/jp/translation.json'

i18n
  .use(LanguageDetector)
  // .use(backend)
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
      jp: { translation: jp },
    },
    fallbackLng: "en",
    debug: false,

    keySeparator: false, // we use content as keys
    parseMissingKeyHandler: () => '',

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
